/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart  Stock',
  'sidebar.resolucionesFacturaciones': 'Resoluciones  Facturaciones',
  'resolucionesFacturaciones.agregarResoluciones Facturaciones': 'Create Resoluciones  Facturaciones',
  'resolucionesFacturaciones.modificarResoluciones Facturaciones': 'Edit Resoluciones  Facturaciones',
  'resolucionesFacturaciones.eliminarResoluciones Facturaciones': 'Delete Resoluciones  Facturaciones',
  'resolucionesFacturaciones.resolucionFacturacionId': 'Resolucion   Facturacion   Id ',
  'resolucionesFacturaciones.empresaId': ' Empresa   Id ',
  'resolucionesFacturaciones.agenciaId': ' Agencia   Id ',
  'resolucionesFacturaciones.bodegaId': ' Bodega   Id ',
  'resolucionesFacturaciones.descripcionResolucionFacturacion': ' Descripcion   Resolucion   Facturacion ',
  'resolucionesFacturaciones.facturaInicio': ' Factura   Inicio ',
  'resolucionesFacturaciones.facturaFin': ' Factura   Fin ',
  'resolucionesFacturaciones.facturaActual': ' Factura   Actual ',
  'resolucionesFacturaciones.fechaInicio': ' Fecha   Inicio ',
  'resolucionesFacturaciones.fechaFin': ' Fecha   Fin ',
  'resolucionesFacturaciones.estado': ' Estado',
  'resolucionesFacturaciones.resoluciones Facturaciones': 'Resoluciones  Facturaciones',
  'resolucionesFacturaciones.verResoluciones Facturaciones': 'View Resoluciones  Facturaciones',
  'resolucionesFacturaciones.bodegaDescripcion': 'Warehouse',
};
